import React from "react";
import ReactDOM from "react-dom";

export default class NotesEditor extends React.Component {
    constructor(props) {
      super(props);
      this.state = { cellValue: props.value };
    }
  
    getValue() {
        let upd = {}
        upd[this.props.column.key] = this.state.cellValue
        return upd;
        /*return { fromRow: this.props.rowData, toRow: this.props.rowData, updated: upd }*/
    }
  
    getInputNode() {
      return ReactDOM.findDOMNode(this).getElementsByTagName("input")[0];
    }
  
    handleChangeComplete = event => {
      this.setState({ cellValue: event.target.value });
    };

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.stopPropagation()
        }
      }

    render() {
      return (
        <textarea style={{resize: "both",width: "400px", height: "400px", top: "13%", left: "40%", position: "fixed"}}
          value={this.state.cellValue}
          onChange={this.handleChangeComplete}
          onKeyDown={this._handleKeyDown} 
        />
      );
    }
  }